import debounce from 'lodash.debounce';

import AnalyticsService, { PageNames, ParamNameAMP } from 'application/services/AnalyticsService';
import { EventNameAMPType } from 'application/services/AnalyticsService/ampTypes';

import BrowserUtils from '@zvuk-b2b/react-uikit/toolkit/BrowserUtils';
import { DropdownItemDataType } from '@zvuk-b2b/react-uikit/ui/Dropdown/types';

import {
  CLEAR_BUTTON_WIDTH,
  DROPDOWN_DESKTOP_BUTTON_WIDTH,
  GRID_GAP,
  MAX_TAG_WIDTH,
  RESIZE_DEBOUNCE_TIME,
  TAG_REST_WIDTH,
} from './consts';
import { DebouncedResizeCallback, GetResizeCallbackParams } from './types';

const MapAmpParamByPageName = {
  point: PageNames.POINT,
  ad_campaign: PageNames.AD_CAMPAIGN,
  video_streams: PageNames.VIDEO_STREAMS,
};

class TagFiltersUtils {
  static sendEvent = (eventName: EventNameAMPType, pageType: 'point' | 'ad_campaign' | 'video_streams') => {
    const ampParam = MapAmpParamByPageName[pageType];

    AnalyticsService.event(eventName, {
      [ParamNameAMP.FILTER_BY_TAG_SOURCE]: ampParam,
    });
  };

  static getCommonWidth = (selectedTags: DropdownItemDataType[]) => {
    const result = selectedTags.reduce((acc, tag) => {
      const tagTitleText = tag.value || '';
      const tagTitleTextWidth = BrowserUtils.getTextWidth(tagTitleText);

      return acc + Math.min(tagTitleTextWidth.width + TAG_REST_WIDTH, MAX_TAG_WIDTH);
    }, CLEAR_BUTTON_WIDTH);

    return result;
  };

  static getResizeCallback = ({
    setShownTags,
    setMoreTagsCount,
    dropdownInTagsRow,
    moreTagsCount,
  }: GetResizeCallbackParams): DebouncedResizeCallback => {
    const resizeCallback = debounce(
      (entries: ResizeObserverEntry[], selectedTags: DropdownItemDataType[], shownTags: DropdownItemDataType[]) => {
        const tagsRow = entries[0].target;

        const isWidthDecreased = tagsRow.scrollWidth !== tagsRow.clientWidth;

        if (isWidthDecreased) {
          setShownTags([...selectedTags]);
        } else {
          let commonWidth = TagFiltersUtils.getCommonWidth(shownTags);

          if (dropdownInTagsRow) {
            commonWidth += DROPDOWN_DESKTOP_BUTTON_WIDTH + GRID_GAP * 2;
          }

          const isWidthIncreased =
            tagsRow.clientWidth - (commonWidth + CLEAR_BUTTON_WIDTH + TAG_REST_WIDTH) > TAG_REST_WIDTH;

          if (isWidthIncreased && moreTagsCount > 0) {
            setShownTags([...selectedTags]);
            setMoreTagsCount(0);
          }
        }
      },
      RESIZE_DEBOUNCE_TIME
    );

    return resizeCallback;
  };
}

export default TagFiltersUtils;
